import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All requests ship the Armada SSO cookie so the shared session is honoured.
axios.defaults.withCredentials = true;
const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  getAuthMe: () => client.get("/auth/me").then((r) => r.data),
  getAdmirals: () => client.get("/admirals").then((r) => r.data),
  getTemplates: () => client.get("/templates").then((r) => r.data),
  getTemplate: (id) => client.get(`/templates/${id}`).then((r) => r.data),
  forgeContract: (template_id, data, counterparty) =>
    client.post("/contracts/forge", { template_id, data, counterparty }).then((r) => r.data),
  listContracts: (status) =>
    client.get("/contracts", { params: status ? { status } : {} }).then((r) => r.data),
  getContract: (id) => client.get(`/contracts/${id}`).then((r) => r.data),
  initiateHandshake: (id) => client.post(`/contracts/${id}/handshake`).then((r) => r.data),
  archiveContract: (id) => client.post(`/contracts/${id}/archive`).then((r) => r.data),
  contractPdfUrl: (id) => `${API}/contracts/${id}/pdf`,
  signLookup: (token) => client.get(`/sign/${token}`).then((r) => r.data),
  signReviewAck: (token) =>
    client.post(`/sign/${token}/review-ack`, { acknowledged: true }).then((r) => r.data),
  signRequestEmailCode: (token, email) =>
    client.post(`/sign/${token}/email-code`, { email }).then((r) => r.data),
  signVerifyEmailCode: (token, code) =>
    client.post(`/sign/${token}/email-verify`, { code }).then((r) => r.data),
  signVerifyIdentity: (token, payload) =>
    client.post(`/sign/${token}/identity-verify`, payload).then((r) => r.data),
  signWithToken: (token, signer_name) =>
    client.post(`/sign/${token}`, { signer_name }).then((r) => r.data),
  forgeStats: () => client.get("/forge/stats").then((r) => r.data),
  purchaseLicense: (payload) => client.post("/forge/license", payload).then((r) => r.data),
  // Fleet Registry
  listFleetApps: (params = {}) => client.get("/fleet/apps", { params }).then((r) => r.data),
  fleetStats: () => client.get("/fleet/stats").then((r) => r.data),
  seedFleet: () => client.post("/fleet/seed").then((r) => r.data),
  createFleetApp: (payload) => client.post("/fleet/apps", payload).then((r) => r.data),
  updateFleetApp: (id, patch) => client.patch(`/fleet/apps/${id}`, patch).then((r) => r.data),
  deleteFleetApp: (id) => client.delete(`/fleet/apps/${id}`).then((r) => r.data),
  // GitHub Arsenal
  githubStatus: () => client.get("/github/status").then((r) => r.data),
  githubLog: (limit = 50) => client.get("/github/log", { params: { limit } }).then((r) => r.data),
  fleetBackup: () => client.post("/fleet/backup").then((r) => r.data),
  // Sovereign Stream Controller
  listBroadcasts: (armed_only = false) =>
    client.get("/broadcasts", { params: armed_only ? { armed_only: true } : {} }).then((r) => r.data),
  getBroadcast: (id) => client.get(`/broadcasts/${id}`).then((r) => r.data),
  createBroadcast: (payload) => client.post("/broadcasts", payload).then((r) => r.data),
  updateBroadcast: (id, patch) => client.patch(`/broadcasts/${id}`, patch).then((r) => r.data),
  deleteBroadcast: (id) => client.delete(`/broadcasts/${id}`).then((r) => r.data),
  broadcastActiveForHull: (hull_key) =>
    client.get(`/broadcast/active/${hull_key}`).then((r) => r.data),
  // Stripe
  createCheckoutSession: (payload) =>
    client.post("/create-checkout-session", payload).then((r) => r.data),
  paymentStatus: (session_id) =>
    client.get(`/payments/status/${session_id}`).then((r) => r.data),
};
